import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FotoService {
  private apiUrl = `${environment.apiUrl}/perfiles-usuario/foto-carnet`;

  constructor(private http: HttpClient) {}
  //
  verificarFotoExiste(usuarioId: string): Observable<boolean> {
    const url = `${this.apiUrl}/${usuarioId}`;
    return this.http.get<{ existe: boolean }>(url).pipe(
      map((res) => res.existe),
      catchError(() => of(false)), // Por si acaso hay error
    );
  }

  // Solo devuelve la URL construida (para usar como src en <img>)
  obtenerFotoCarnetUrl(usuarioId: string): string {
    return `${this.apiUrl}/${usuarioId}`;
  }

  // También puedes tener esta si quieres traer la imagen como blob
  obtenerFotoComoBlob(usuarioId: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${usuarioId}`, {
      responseType: 'blob',
    });
  }

  obtenerFotoBase64(
    usuarioId: string,
  ): Promise<{ base64: string } | undefined> {
    return this.http
      .get<{ base64: string }>(`${this.apiUrl}/${usuarioId}/base64`)
      .toPromise()
      .catch((err) => {
        console.error('    Error al obtener base64 del carnet:', err);
        return undefined;
      });
  }
}
